<mat-dialog-content class="text-center">
  <div class="container-popup">
    <div class="header">
      <span class="header-title">{{ existingClub ? 'Update' : 'Create' }} Club</span>
      <span class="header-close">
        <button mat-icon-button (click)="onNoClick()">
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </div>

    <form #formData="ngForm">
      <div>
        <div class="field">
          <label for="clubname">Club Name</label>
          <input id="clubname" pInputText class="w-full" type="text" name="clubname" placeholder="Enter your clubname"
            [(ngModel)]="club.clubName" required #clubname="ngModel" />
          <small *ngIf="clubname.invalid && (clubname.touched || clubname.dirty)">
            <div *ngIf="clubname.errors?.['required']" style="color: red;">*Clubname is required</div>
          </small>
        </div>

        <div class="field">
          <label for="address1">Address 1</label>
          <input id="address1" pInputText class="w-full" type="text" name="address1" maxlength="250"
            placeholder="Enter your address 1" [(ngModel)]="club.address1" required #address="ngModel" />
          <small *ngIf="address.invalid && (address.touched || address.dirty)">
            <div *ngIf="address.errors?.['required']" style="color: red;">*Address is required</div>
          </small>
        </div>

        <div class="field">
          <label for="address2">Address 2</label>
          <input id="address2" pInputText class="w-full" type="text" name="address2" maxlength="250"
            placeholder="Enter your address 2" [(ngModel)]="club.address2" />
        </div>

        <div class="field">
          <label for="city">City</label>
          <input id="city" pInputText class="w-full" type="text" name="city" placeholder="Enter your city"
            maxlength="100" [(ngModel)]="club.city" pattern="[A-Za-z,0-9 ]*" required #city="ngModel" />
          <small *ngIf="city.invalid && (city.touched || city.dirty)" style="color: red;">
            <div *ngIf="city.errors?.['pattern']" style="color: red;">*Enter valid City</div>
            <div *ngIf="city.errors?.['required']" style="color: red;">*City is required</div>
          </small>
        </div>

        <div class="field">
          <label for="state">State</label>
          <select id="state" name="state" [(ngModel)]="club.state" required placeholder="Select State" class="w-full"
            #state="ngModel">
            <option [ngValue]="club.state" disabled selected>{{ club.state.name }}</option>
            <option *ngFor="let state of states" [ngValue]="state">
              {{ state.code }} - {{ state.name }}
            </option>
          </select>
          <small *ngIf="state.invalid && state.touched" style="color: red;">* State is required</small>
        </div>

        <div class="field">
          <label for="zip">Zip</label>
          <input id="zip" pInputText class="w-full" type="text" name="zip" maxlength="5" minlength="5" pattern="^\d{5}$"
            placeholder="Enter your Zip" [(ngModel)]="club.zip" #zip="ngModel" required
            [value]="club.zip === '0' ? '' : club.zip" />
          <small *ngIf="zip.invalid && (zip.dirty || zip.touched)" class="small-error">
            <div *ngIf="zip.errors?.['pattern']" style="color: red;">*Enter valid 5 digit zip</div>
            <div *ngIf="zip.errors?.['required']" style="color: red;">*Zipcode is required</div>
          </small>
        </div>

        <div class="field">
          <label for="sport">Sport</label>
          <select id="sport" name="sport" [(ngModel)]="club.sport" required placeholder="Select Sport"
            (change)="getCourts()" class="w-full" #sport="ngModel">
            <option [ngValue]="club.sport" disabled selected>{{ club.sport.name }}</option>
            <option *ngFor="let sport of sports" [ngValue]="sport">{{ sport.name }}</option>
          </select>
          <small *ngIf="sport.invalid && sport.touched" style="color: red;">* Sport is required</small>
        </div>

        <div class="field">
          <label for="homeCourt">Home Court</label>
          <select id="homeCourt" name="homeCourt" [(ngModel)]="club.homeCourt" required placeholder="Select Court"
            class="w-full" #court="ngModel">
            <option [ngValue]="club.homeCourt" disabled selected>{{ club.homeCourt.name }}</option>
            <option *ngFor="let court of courts" [ngValue]="court">{{ court.name }}</option>
          </select>
          <small *ngIf="court.invalid && court.touched" style="color: red;">*Home court is required</small>
        </div>
        <div class="field">
          <label for="calculationType">Calculation Type </label>
      <select
  name="calculationType"
  [(ngModel)]="club.calculationType"
  required
  class="w-full" #calculationType="ngModel">

  <option [ngValue]="null">Select Calculation Type</option>

  <option *ngFor="let ct of calculationTypes" [ngValue]="ct">
    {{ ct.description }}
  </option>
</select>


          <small *ngIf="calculationType.invalid && calculationType.touched" style="color: red;">*Calculation type is required</small>
        </div>

        <div class="field">
          <label for="paymentOptions">Payment Options</label>
              <div class="desktop-payment" *ngIf ="!isMobile">
                <div class="form-check form-switch d-flex" id="paymentOptions">
                  <ng-container *ngFor="let payment of club.payments; let i = index">
                    <div class="form-check">
                      <input class="mt-3 form-check-input" type="checkbox" [id]="'paymentOption' + i"
                        [(ngModel)]="payment.checked" [name]="'paymentOption' + i" />
                      <label class="form-check-label me-5" [for]="'paymentOption' + i">
                        {{ payment.paymentOption }}
                      </label>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="mobile-payment" *ngIf="isMobile">
                    <div class="payment-card-group">
                      <div 
                        class="payment-card"
                        *ngFor="let payment of club.payments; let i = index"
                        [class.active]="payment.checked"
                        (click)="payment.checked = !payment.checked">
                        <div class="payment-left">
                          <div class="circle" [class.checked]="payment.checked"></div>
                          <span>{{ payment.paymentOption }}</span>
                        </div>
                      </div>
                    </div>     
              </div>
          </div>
          

        <div class="field d-flex payment-options">
          <ng-container *ngIf="club?.payments?.[0] as venmo">
            <ng-container *ngIf="venmo.checked">
              <div class="field">
                <input
                  id="Venmo"
                  pInputText
                  class="w-full"
                  type="text"
                  name="Venmo"
                  maxlength="250"
                  placeholder="Enter your email / phone number for Venmo"
                  [(ngModel)]="venmo.payTo"
                  #venmoPayTo="ngModel"
                  required
                  pattern="(^\d{10}$)|(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)"
                />
                <small *ngIf="venmoPayTo.invalid && (venmoPayTo.dirty || venmoPayTo.touched)">
                  <div *ngIf="venmoPayTo.errors?.['required']" style="color: red;">*Venmo is required</div>
                  <div *ngIf="venmoPayTo.errors?.['pattern']" style="color: red;">
                    *Enter a valid email or 10-digit phone number
                  </div>
                </small>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="club?.payments?.[1] as zelle">
            <ng-container *ngIf="zelle.checked">
              <input
                id="Zelle"
                pInputText
                class="w-full"
                type="text"
                name="Zelle"
                maxlength="250"
                placeholder="Enter your email / phone number for Zelle"
                [(ngModel)]="zelle.payTo"
                #zellePayTo="ngModel"
                required
                pattern="(^\d{10}$)|(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)"
              />
              <small *ngIf="zellePayTo.invalid && (zellePayTo.dirty || zellePayTo.touched)">
                <div *ngIf="zellePayTo.errors?.['required']" style="color: red;">*Zelle is required</div>
                <div *ngIf="zellePayTo.errors?.['pattern']" style="color: red;">
                  *Enter a valid email or 10-digit phone number
                </div>
              </small>
            </ng-container>
          </ng-container>
        </div>

        <div class="mb-3 d-flex justify-content-between" style="margin-top: 15px;">
          <button type="submit" class="registerBtn create-btn" [disabled]="isSubmitDisabled(formData)"
            (click)="this.dialogRef.close(this.club);">
            <span><mat-icon>check</mat-icon></span>
            <span>{{ existingClub ? 'Update' : 'Create' }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>